export default "__VITE_ASSET__CC7x1SjB__"